import { render, staticRenderFns } from "./CbxMortgageRateType.vue?vue&type=template&id=9feaa3fe&"
import script from "./CbxMortgageRateType.vue?vue&type=script&lang=ts&"
export * from "./CbxMortgageRateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports